import { px } from "../util";

const usersListTooltipElement = (): HTMLElement => {
  const el = document.getElementsByTagName("users-list-tooltip")[0] as HTMLElement;
  if (!el) {
    throw new Error("Cannot find users list tooltip element");
  }

  return el;
};

export const showUsersListTooltip = (coordinates?: { x: number; y: number }): void => {
  const usersListTooltipEl = usersListTooltipElement();

  if (coordinates) {
    usersListTooltipEl.style.top = px(coordinates.y);
    usersListTooltipEl.style.left = px(coordinates.x);
  }

  usersListTooltipEl.style.visibility = "visible";
};

export const hideUsersListTooltip = (): void => {
  const usersListTooltipEl = usersListTooltipElement();
  usersListTooltipEl.style.visibility = "hidden";
};
